import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

import { ArticleFavoriteToggleResponse } from '../../types/article';

export const articleFavoriteApiClient = {
  toggle: async (articleId: number): Promise<ApiResult<ArticleFavoriteToggleResponse>> => {
    return await axiosClient.post(`/company/articles/${articleId}/favorite`, {});
  },
};
